(function () {
  function formatMoney(cents) {
    try {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function calc(section) {
    const box = section.querySelector(".bakons-bundle__summary");
    if (!box) return;

    const main = Number(box.dataset.mainCents || 0);
    const bundle = Number(box.dataset.bundleCents || 0);
    const percent = Number(box.dataset.discountPercent || 0);
    const scope = String(box.dataset.discountScope || "bundle_only").toLowerCase();

    const raw = main + bundle;

    let saved = 0;
    let total = raw;

    if (percent > 0) {
      if (scope === "both") {
        // Old logic: discount applies to both items
        saved = Math.round(raw * (percent / 100));
        total = raw - saved;
      } else {
        // ✅ New logic: discount applies ONLY to the bundle product (Buy X Get Y)
        saved = Math.round(bundle * (percent / 100));
        total = raw - saved;
      }
    }

    const totalEl = box.querySelector(".bakons-bundle__total");
    const savedWrap = box.querySelector(".bakons-bundle__save");
    const savedEl = box.querySelector(".bakons-bundle__saved");

    if (totalEl) totalEl.textContent = formatMoney(total);

    if (saved > 0 && savedWrap && savedEl) {
      savedWrap.style.display = "";
      savedEl.textContent = formatMoney(saved);
    } else if (savedWrap) {
      savedWrap.style.display = "none";
    }
  }

  async function addBundle(items, btn) {
    btn.disabled = true;
    const oldText = btn.textContent;
    btn.textContent = "Adding...";

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error("Add to cart failed");

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));

      btn.textContent = "Added ✓";
      setTimeout(() => (btn.textContent = oldText), 900);
    } catch (e) {
      btn.textContent = "Try again";
      console.error(e);
      alert("Sorry, failed to add bundle. Please try again.");
      setTimeout(() => (btn.textContent = oldText), 900);
    } finally {
      btn.disabled = false;
    }
  }

  function bind(section) {
    calc(section);

    const addBtn = section.querySelector("[data-add-bundle]");
    if (addBtn) {
      addBtn.addEventListener("click", () => {
        const items = JSON.parse(addBtn.getAttribute("data-items") || "[]");
        addBundle(items, addBtn);
      });
    }

    const codeBtn = section.querySelector(".bakons-bundle__codebtn");
    if (codeBtn) {
      codeBtn.addEventListener("click", async () => {
        const code = codeBtn.dataset.code || "";
        try {
          await navigator.clipboard.writeText(code);
          const old = codeBtn.textContent;
          codeBtn.textContent = "Copied ✓";
          setTimeout(() => (codeBtn.textContent = old), 900);
        } catch (e) {
          prompt("Copy this code:", code);
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".bakons-bundle").forEach(bind);
  });
})();
